import ApiService from '@/services/api.service';

export const RecallAnswerTextService = {
  index(params) {
    return ApiService.query('recall/answer_texts', {
      params,
    });
  },
  show(slug) {
    return ApiService.get('recall/answer_texts', slug);
  },
  create(params) {
    return ApiService.post('recall/answer_texts', {
      data: params,
    });
  },
  update(slug, params) {
    return ApiService.update('recall/answer_texts', slug, {
      data: params,
    });
  },
  destroy(slug) {
    return ApiService.delete('recall/answer_texts', slug);
  },
};

export default RecallAnswerTextService;
